
    import {Component, Vue} from 'vue-property-decorator';

    @Component({})
    export default class Layout extends Vue {
        openMenu = false;
        filename = window.location.pathname.split('/').pop();
        mounted() {
            // Scroll automatically to make the active menu visible
            const menu = this.$refs.menu as HTMLElement;
            menu.querySelector('a.underline')?.scrollIntoView(false);
            menu.scrollTop += 30;
        }
    }
